import React from 'react';
import qs from 'qs';
import PropTypes from 'prop-types';
import { history } from '../../init-store';
import Button from '../button';

const SignUpCancelButton = ({ setField, nextStep }) => {
  return (
    <Button
      color="dark-gray"
      transparency="full"
      xSize="full"
      className="js-cancel-button page_control -no-border -cancel font-weight-bold"
      onClick={() => {
        const { from } = qs.parse(window.location.search, { ignoreQueryPrefix: true });
        if (from === 'dashboard') {
          history.push('/dashboard');
        } else {
          setField('step', nextStep);
        }
      }}
    >
      Cancel
    </Button>
  );
};

SignUpCancelButton.propTypes = {
  setField: PropTypes.func,
  nextStep: PropTypes.string,
};

export default SignUpCancelButton;
